<template>
  <div class="inventory">
    <div class="inventory-box">
      <div class="inventory-title">
        <p>{{areaname}}权责清单调整统计</p>
      </div>
    </div>
    <div class="inventory-box">
      <div class="inventory-time">
        <div class="inventory-label">时间：</div>
        <div class="inventory-input">
          <timeSelect :selectDay="firstDay" @getDate="getStartDate"></timeSelect>
        </div>
        <div class="inventory-label">至</div>
        <div class="inventory-input">
          <timeSelect :selectDay="endDay" @getDate="getEndDate"></timeSelect>
        </div>
        <div class="inventory-label">
          <button type="button" @click="initModifyCollect">查询</button>
        </div>
      </div>
      <!-- <div class="inventory-select">
        <seclectInput :value="unitValue" @getselect="getType" :selectlist="unitSelect" left="-290"></seclectInput>
      </div>-->
    </div>
    <div class="inventory-box">
      <div class="inventory-table-box">
        <table class="inventory-table">
          <colgroup>
            <col width="15%" />
            <col width="8%" />
            <col width="8%" />
            <col width="8%" />
            <col width="8%" />
            <col width="8%" />
            <col width="8%" />
            <col width="8%" />
            <col width="10%" />
            <col width="11%" />
            <col width="8%" />
          </colgroup>
          <thead>
            <tr>
              <td>
                <p>职权类别</p>
              </td>
              <td>
                <p>保留</p>
              </td>
              <td>
                <p>新增</p>
              </td>
              <td>
                <p>取消</p>
              </td>
              <td>
                <p>下放</p>
              </td>
              <td>
                <p>合并</p>
              </td>
              <td>
                <p>转入</p>
              </td>
              <td>
                <p>转出</p>
              </td>
              <td>
                <p>调整要素</p>
              </td>
              <td>
                <p>调整为日常工作</p>
              </td>
              <td>
                <p>合计</p>
              </td>
            </tr>
            <!-- <tr>
              <td rowspan="2" colspan="2">
                <p>职权类别</p>
              </td>
              <td colspan="2">
                <p>保留</p>
              </td>
              <td colspan="2">
                <p>新增</p>
              </td>
              <td colspan="2">
                <p>取消</p>
              </td>
              <td colspan="2">
                <p>下放</p>
              </td>
              <td>
                <p>合并</p>
              </td>
              <td colspan="2">
                <p>转入</p>
              </td>
              <td colspan="2">
                <p>转出</p>
              </td>
              <td colspan="2">
                <p>调整要素</p>
              </td>
              <td colspan="2">
                <p>调整为日常工作</p>
              </td>
              <td colspan="2">
                <p>合计</p>
              </td>
            </tr>-->
            <!-- <tr>
              <td>
                <p>主项</p>
              </td>
              <td>
                <p>办理项</p>
              </td>
              <td>
                <p>主项</p>
              </td>
              <td>
                <p>办理项</p>
              </td>
              <td>
                <p>主项</p>
              </td>
              <td>
                <p>办理项</p>
              </td>
              <td>
                <p>主项</p>
              </td>
              <td>
                <p>办理项</p>
              </td>
              <td>
                <p>主项</p>
              </td>
              <td>
                <p>办理项</p>
              </td>
              <td>
                <p>主项</p>
              </td>
              <td>
                <p>主项</p>
              </td>
              <td>
                <p>办理项</p>
              </td>
              <td>
                <p>主项</p>
              </td>
              <td>
                <p>办理项</p>
              </td>
              <td>
                <p>主项</p>
              </td>
              <td>
                <p>办理项</p>
              </td>
              <td>
                <p>主项</p>
              </td>
              <td>
                <p>办理项</p>
              </td>
            </tr>-->
          </thead>
          <tbody>
            <tr v-for="(act, index) in actList" :key="index">
              <td>
                <p>{{act.Name}}</p>
              </td>
              <td
                v-for="(model,modelKey) in act.TypeCollectModel"
                :key="modelKey"
                v-show="modelKey.indexOf('child') < 0"
              >
                <p>{{model}}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
// import seclectInput from "@/components/selectVue.vue";
import timeSelect from "@/components/timeSelect.vue";
export default {
  props: {
    areacode: {
      type: [String, Number],
      default: "00",
    },
    areaname: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      firstDay: "",
      endDay: "",
      // unitValue: "请选择部门",
      // unitSelect: [],
      // menuName: "",
      deptId: -1,
      affairTypeId: 1,
      actList: [],
    };
  },
  watch: {
    areacode: {
      immediate: true,
      handler(newValue, old) {
        this.initModifyCollect();
      },
    },
  },
  components: {
    // seclectInput,
    timeSelect,
  },
  methods: {
    getStartDate(value) {
      this.firstDay = value;
    },
    getEndDate(value) {
      this.endDay = value;
    },
    initTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      this.firstDay = `${year}-01-01`;
      this.endDay = `${year}-${month}-${day}`;
    },
    // initUnitList() {
    //   this.$axios({
    //     url: "api/getDeptList",
    //     type: "get",
    //     params: {
    //       areacode: "00",
    //       deptId: this.unitId,
    //       keyword: this.keyword
    //     }
    //   })
    //     .then(res => {
    //       this.unitSelect = res.data.deptList;
    //     })
    //     .catch(err => {
    //       console.info(err);
    //     });
    // },
    initModifyCollect() {
      if (!this.firstDay || !this.endDay) {
        this.initTime();
      }
      this.$axios({
        url: "api/GetModifyCollectByTypeId",
        type: "get",
        params: {
          areacode: this.areacode,
          deptId: this.deptId,
          affairTypeId: this.affairTypeId,
          startdate: this.firstDay,
          enddate: this.endDay,
        },
      })
        .then((res) => {
          this.actList = res.data.actList;
        })
        .catch((err) => {
          console.info(err);
        });
    },
  },
  created() {
    this.initTime();
    // this.initUnitList();
    // this.initModifyCollect();
  },
};
</script>
<style lang="scss" scoped>
.inventory {
  width: 100%;
  height: auto;
  position: relative;
  background: linear-gradient(180deg, transparent, transparent, #ffffff);
  padding: 10px 0;
  // position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  .inventory-box {
    width: 100%;
    height: auto;
    display: flex;
    .inventory-title {
      width: 100%;
      padding: 60px 0;
      height: auto;
      p {
        width: 100%;
        font-size: 35px;
        letter-spacing: 5px;
        color: #212121;
      }
    }
    .inventory-time {
      width: auto;
      height: auto;
      display: flex;
      padding: 0 20px;
      .inventory-label {
        width: auto;
        padding: 0 10px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        color: #212121;
        button {
          width: 50px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border: 0px;
          background-color: #c0392b;
          color: #ffffff;
          cursor: pointer;
          outline: none;
        }
      }
      .inventory-input {
        width: 150px;
        height: 40px;
        border: 1px solid #ebebeb;
        input {
          width: 100%;
          height: 100%;
          font-size: 14px;
          line-height: 40px;
        }
      }
    }
    .inventory-table-box {
      width: 100%;
      height: auto;
      padding: 10px 30px;
      margin-bottom: 100px;
      .inventory-table {
        width: 100%;
        border-collapse: collapse;
        p {
          width: 100%;
          min-height: 40px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          font-size: 14px;
        }
        tr {
          td {
            border-bottom: 1px solid #fceaea;
            border-left: 1px solid #fceaea;
            &:last-of-type {
              border-right: 1px solid #fceaea;
            }
            &:first-of-type {
              background-color: #f5f6fa;
            }
          }
        }
        // tbody {
        //   tr:last-of-type {
        //     td {
        //       border-bottom: 1px solid #fceaea;
        //     }
        //   }
        // }
        thead {
          tr {
            td {
              background-color: #f5f6fa;
            }
          }
        }
      }
    }
  }
}
</style>
